

import { Link } from 'react-router-dom'
import '../../assets/css/iso-style.css'
import { useDispatch, useSelector } from 'react-redux';
import { fetcharticle, getArticle } from '../../reducers/resumeSlice';
import $ from 'jquery';

const BlogIsotope = ({ weblogInfo }) => {
    console.log(weblogInfo);
    const dispatch = useDispatch()
    // store.dispatch(fetchadminInfo());
    const selectArticle = useSelector(getArticle)
    const filtersDefault = weblogInfo.blogFilter
    // console.log(filtersDefault);

    const cardsLayout = weblogInfo.blog
    // console.log(cardsLayout);

    const openArticle = (a) => {
        dispatch(fetcharticle({ article: a }));
        localStorage.setItem("article", JSON.stringify(a));
        $(".animated-section").removeClass("section-active");
        $(".article").addClass("section-active");
        $(".article").addClass("custom-anim");
    }


    // console.log("start load data")
    return (
        <>
            <div className="portfolio-iso grid">

                <div id="filters-blog" className="gallery-filters filters position-relative">
                    <button className="item item-button  d-inline-block" data-filter='*'>
                        <span className="d-inline-block text-center">همه</span>
                    </button>
                    {filtersDefault.map((element, index) => {
                        // console.log(card.filter);
                        return (
                            <button key={element.id} className="item item-button  d-inline-block" data-filter={`.${element.label}`}>
                                <span className="d-inline-block text-center">{element.title}</span>
                            </button>
                        );
                    })}
                </div>

                <div className="blog-list-box mt-3 mt-sm-0">

                    {cardsLayout.map((card, index) => {
                        var classnames = 'grid-item iso-item col-sm-6';
                        // console.log(card.filter);
                        card.filter.map((element, index) => {
                            classnames = classnames + ' ' + element
                        })

                        // console.log(classnames);
                        return (
                            <div key={card.id} className={classnames}>
                                <a href={`#article-${card.id}`} className="blog-item position-relative blogItem" onClick={() => openArticle(card)}>
                                    <div className="post-img position-relative overflow-hidden">
                                        <p className="d-block">
                                            <img src={`https://amirsabit.4api.ir/uploads/Blog/${card.iso_image}`} title={card.name} alt={card.name} className="img-fluid" />
                                        </p>
                                        <div className="category">
                                            <span className="d-inline-block">{card.category}</span>
                                        </div>
                                        <div className="mask"></div>
                                    </div>
                                    <div className="post-info">
                                        <div className="date">{card.date}</div>
                                        <div className="post-title">
                                            {card.name}
                                        </div>
                                    </div>
                                </a>
                            </div>
                        );
                    })}

                </div>
            </div>

        </>
    )
}

export default BlogIsotope;